import { computed, reactive } from '@vue/composition-api';

import { mixpanel } from '@/helpers/analytics';
import { toastError, closeAllToasts } from '@/helpers/toast';

import {
  createTopicBookmark,
  deleteTopicBookmark,
} from '@/modules/advisor-search/api/useTopicBookmarkApi';
import { useTopicBookmarkStatusesWithSWRV } from '@/modules/advisor-search/api/useTopicBookmarkStatusesWithSWRV';

export const useAdvisorSearchUserTopicBookmark = (
  props: {
    topicId: number;
  },
  isSp: boolean,
) => {
  const { data, mutateStatusByTopicId } = useTopicBookmarkStatusesWithSWRV();
  const state = reactive({ submitting: false });
  const bookmarkStatus = computed(() => data.value?.[props.topicId]);

  const toggle = async () => {
    closeAllToasts();
    state.submitting = true;
    const newStatus = !bookmarkStatus.value;
    if (newStatus) {
      try {
        await createTopicBookmark(props.topicId);
        mutateStatusByTopicId(props.topicId, newStatus);
        mixpanel.track('Bookmark Created', {
          page: location.pathname,
          is_sp: isSp,
          targetType: 'Topic',
          targetId: props.topicId,
        });
      } catch {
        toastError('ブックマーク追加時にエラーが発生しました');
      } finally {
        state.submitting = false;
      }
    } else {
      try {
        await deleteTopicBookmark(props.topicId);
        mutateStatusByTopicId(props.topicId, newStatus);
        mixpanel.track('Bookmark Dropped', {
          page: location.pathname,
          is_sp: isSp,
          target_type: 'Topic',
          target_id: props.topicId,
        });
      } catch {
        toastError('ブックマーク削除時にエラーが発生しました');
      } finally {
        state.submitting = false;
      }
    }
  };

  return {
    state,
    bookmarkStatus,
    toggle,
  };
};
